export const FeatureFlags = {
  ActivityLogs: "core:activity_logs",
  Alerting: "core:alerting",
  AssetGroups: "core:asset_groups",
  Assistant: "core:assistant",
  Comments: "core:comments",
  CreateFormSchemas: "forms:schemas_create",
  Dashboards: "core:dashboards",
  DashboardsInsights: "dashboards:insights",
  DashboardsManageInsights: "dashboards:manage_insights",
  DataIngest: "legacy:data_ingest",
  DataPipeline: "core:data_pipeline",
  DevAlpha: "dev:alpha",
  DevBeta: "dev:beta",
  Devices: "core:devices",
  EmissionsOverview: "legacy:emissions_overview",
  EmissionsReporting: "legacy:emissions_reporting",
  Equipment: "core:equipment",
  EstimationMethods: "core:estimation_methods",
  Events: "core:events",
  Facilities: "core:facilities",
  Flows: "core:flows",
  Forms: "core:forms",
  Home: "core:home",
  InvestigationsMvp: "investigations:mvp",
  LegacyDashboards: "core/dashboards",
  LegacyInsightsDashboard: "core/insights_dashboard",
  LocalizeExports: "core:localize_exports",
  MobileApp: "core:mobile_app",
  Networks: "core:networks",
  Records: "core:records",
  StratosExternalApiRegistry: "stratos:external_api_registry",
  RolesPermissions: "core:roles_permissions",
  Scenarios: "core:scenarios",
  TemplatedConfigurations: "core:templated_configurations",
  UserInterfaceConfigurations: "core:user_interface_configurations",
  VolumetricEstimationMethods: "core:volumetric_estimation_methods",
  VolumetricReporting: "core:volumetric_reporting",
  WorkflowTaskComments: "comments:workflow_tasks",
  Workflows: "core:workflows",
  WorkflowsAiSummary: "workflows:ai_summary",
  WorkflowsVisualization: "workflows:visualization",
  CTRAnnotation: "legacy:ctr",
  CustomCodeFeatureFlag: "core:custom_code",
} as const;
